import { asc, eq } from "drizzle-orm";
import { type PowerSyncDrizzleDB, subtask } from "@listto/powersync";

/**
 * Shared Drizzle query builder for fetching subtasks by todo id.
 */
export function getSubtasksByTodoQuery(db: PowerSyncDrizzleDB, todoId: string) {
  return db
    .select()
    .from(subtask)
    .where(eq(subtask.todo_id, todoId))
    .orderBy(asc(subtask.order), asc(subtask.created_at));
}
